import isNumber from 'lodash/isNumber';
import { imageUrl } from './image';
import { Device } from './media';
export function responsiveSizes(sizes, image, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
additionalTransformations) {
    // Get all responsive sizes //
    const breakpoints = Object.values(Device)
        .filter((x) => isNumber(x))
        .map((x) => Number(x));
    const images = {};
    for (let i = 0; i < sizes.length; i++) {
        const size = sizes[i];
        const previousSize = i > 0 ? sizes[i - 1] : undefined;
        if (size.breakpoint) {
            // We can use the breakpoint to work out which sizes to render //
            const breakpoint = size.breakpoint; // Stops stupid linting error about size.breakpoint being undefined.... when it isn't //
            // Get the range of sizes from the previous size to this size //
            let sizeRange = breakpoints.filter((x) => x <= breakpoint);
            if (previousSize) {
                const previousBreakpoint = previousSize.breakpoint;
                if (previousBreakpoint) {
                    sizeRange = sizeRange.filter((x) => x > previousBreakpoint);
                }
            }
            const scaledValues = sizeRange.map((s) => Math.round(s * (size.value / 100)));
            scaledValues.forEach((scaledValue) => {
                if (scaledValue >= Device.MobileSmall) {
                    images[scaledValue] = `${imageUrl(image, {
                        width: scaledValue,
                        ...additionalTransformations,
                    })} ${scaledValue}w`;
                }
            });
        }
        else {
            let sizeRange = breakpoints;
            if (previousSize) {
                const previousBreakpoint = previousSize.breakpoint;
                if (previousBreakpoint) {
                    sizeRange = sizeRange.filter((x) => x > previousBreakpoint);
                }
            }
            const scaledValues = sizeRange.map((s) => Math.round(s * (size.value / 100)));
            scaledValues.forEach((scaledValue) => {
                if (scaledValue >= Device.MobileSmall) {
                    images[scaledValue] = `${imageUrl(image, {
                        width: scaledValue,
                        ...additionalTransformations,
                    })} ${scaledValue}w`;
                }
            });
        }
    }
    return Object.entries(images)
        .map((x) => x[1])
        .join(', ');
}
